import { FormControl, SxProps, Theme } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs, { Dayjs } from 'dayjs';
import React from 'react';

export type DateFieldOptions = {
  label?: string;
  placeholder?: string;
  onChange?: Function;
  value?: string | Dayjs;
  sx?: SxProps<Theme>;
  minDate?: string;
  defaultValue?: string | Dayjs;
  disableFuture?: boolean;
  disabled?: boolean;
  clearable?: boolean;
};

export const CalendarField = React.forwardRef<HTMLInputElement, DateFieldOptions>((props, ref) => {
  const { label, onChange, value, sx, disableFuture, disabled } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <FormControl fullWidth>
        <DatePicker
          slotProps={{
            popper: {
              sx: { zIndex: 1197 },
            },
            textField: { placeholder: 'DD/MM/YYYY' },
            ...(props.clearable ? { actionBar: { actions: ['clear'] } } : {}),
          }}
          {...(props.minDate && { minDate: dayjs(props.minDate) })}
          format='DD/MM/YYYY'
          label={label}
          value={value ? dayjs(value) : null}
          onChange={(newValue) => {
            if (onChange && typeof onChange === 'function' && newValue === null) {
              onChange(newValue);
              return;
            }
            if (onChange && typeof onChange === 'function') {
              onChange(newValue?.format('YYYY-MM-DD'));
            }
          }}
          inputRef={ref}
          sx={sx}
          disableFuture={disableFuture}
          disabled={disabled}
        />
      </FormControl>
    </LocalizationProvider>
  );
});
